/**
 * Calcola l'età in anni da una data di nascita
 * @param {string|Date} dataNascita - Data di nascita (YYYY-MM-DD o Date object)
 * @returns {number|null} Età in anni o null se data non valida
 */
export const calcolaEta = (dataNascita) => {
  if (!dataNascita) return null;
  
  const nascita = new Date(dataNascita);
  if (isNaN(nascita.getTime())) return null;
  
  const oggi = new Date();
  let eta = oggi.getFullYear() - nascita.getFullYear();
  const meseCorrente = oggi.getMonth();
  const meseNascita = nascita.getMonth();
  
  // Verifica se il compleanno non è ancora passato quest'anno
  if (meseCorrente < meseNascita || 
      (meseCorrente === meseNascita && oggi.getDate() < nascita.getDate())) {
    eta--;
  }
  
  return eta;
};

/**
 * Formatta l'età per la visualizzazione
 * @param {string|Date} dataNascita - Data di nascita
 * @returns {string} Stringa formattata (es. "82 anni")
 */
export const formatEta = (dataNascita) => {
  const eta = calcolaEta(dataNascita);
  if (eta === null) return '';
  return `${eta} anni`;
};

/**
 * Formatta la data di nascita in formato italiano
 * @param {string} dataNascita - Data in formato YYYY-MM-DD
 * @returns {string} Data formattata (es. "15 marzo 1942")
 */
export const formatDataNascita = (dataNascita) => {
  if (!dataNascita) return '';
  
  const data = new Date(dataNascita);
  if (isNaN(data.getTime())) return '';
  
  return data.toLocaleDateString('it-IT', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};
